import { render, staticRenderFns } from "./LisProjectEdit.vue?vue&type=template&id=37fe4390&scoped=true"
import script from "./LisProjectEdit.vue?vue&type=script&lang=js"
export * from "./LisProjectEdit.vue?vue&type=script&lang=js"
import style0 from "./LisProjectEdit.vue?vue&type=style&index=0&id=37fe4390&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fe4390",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37fe4390')) {
      api.createRecord('37fe4390', component.options)
    } else {
      api.reload('37fe4390', component.options)
    }
    module.hot.accept("./LisProjectEdit.vue?vue&type=template&id=37fe4390&scoped=true", function () {
      api.rerender('37fe4390', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/lisProject/LisProjectEdit.vue"
export default component.exports